import { inject } from 'vue'
import type { Rogue } from './sisuTypes'

export function useRogue(): Rogue {
  const rogue = inject<Rogue>('ROGUE')
  if (!rogue) {
    throw new Error('Global context not provided')
  }

  return rogue
}